/* eslint-disable react/jsx-max-props-per-line */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, DialogContentText } from '@material-ui/core';
import moment from 'moment';
import { 
  DialogDefault, 
  Input,
  InputFormat,
  OptionSelect,
  ArquivoContainer,
  Widget,
} from '../../../components';

import * as selectorsAuth from '../../../store/auth/reducer';
import * as selectorsNsir from '../../../store/nsir/reducer';
import * as selectorsNsmp from '../../../store/nsmp/reducer';
import * as actionsSubNsmp from '../../../store/subNsmp/actions';
import * as actionsNsmp from '../../../store/nsmp/actions';
import * as Role from '../../../constants/role';
import * as Status from '../../../constants/status';
import { isUsuarioUsoMuto } from 'utils';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(1)
  }, 
  fieldContainer: {
    paddingBottom: '0px !important'
  },
  posteContainer: {
    padding: 12,
    border: theme.palette.bar.border,
  },
  image: {
    height: 50
  },
  required: {
    color: 'red',
    paddingTop: 5
  },
  dialogContent: {
    overflow: 'auto'
  },
  evidenciaContent: {
    padding: '16px',
  },
}));

const UsoMutuoNewModal = ({ open, onCancel, onConfirm, selectedId, nsmps, nsmpSelected, loadNsmpById, readOnly, userRole, authData,
  nsirStatus, nsirTitle, digitadorId, inspetorId, userId, validateInvalidateSubNsmp, cloneSubNsmp, deleteCloneSubNsmp }) => {

  const classes = useStyles();
  const [canEditNsmp, setCanEditNsmp] = useState(false);
  const [readOnlyLocal, setReadOnlyLocal] = useState(readOnly);
  const [editFiles, setEditFiles] = useState(false);
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({ dataFotoDrone: moment().valueOf(), fotos: [] });
  const [ocorrenciaData, setOcorrenciaData] = useState({ open: false, type: "", subNmspId: null, subNsmpCodigo: null, });
  const [clonarData, setClonarData] = useState({ open: false, subNmspId: null, subNsmpCodigo: null, });
  const [deletarData, setDeletarData] = useState({ open: false, subNmspId: null, subNsmpCodigo: null, });

  useEffect(() => {
    setReadOnlyLocal(readOnly);
  }, [readOnly])

  useEffect(() => {
    if (selectedId) loadNsmpById(selectedId);
  }, [selectedId, loadNsmpById]);

  useEffect(() => {
    if (nsmpSelected && nsmpSelected.id) {
      setValues(nsmpSelected);
    }
  }, [nsmpSelected]);

  const handleChange = (id, value) => {
    setValues({
      ...values,
      [id]: value
    });
  };

  const clearForm = () => {
    setCanEditNsmp(false);
    setEditFiles(false);
    setErrors({});
    setValues({ fotos: [], dataFotoDrone: moment().valueOf() });
  }

  const onCancelLocal = () => {
    clearForm();
    onCancel();
  }

  const getDataFotoDrone = () => {
    let data = moment().valueOf();

    if (values.dataFotoDrone) {
      data = values.dataFotoDrone;
    }
    
    return moment(data).valueOf();
  }

  const onConfirmLocal = () => {
    let errors = {};
    setErrors(errors);
    if (!errors || (errors && Object.keys(errors).length === 0)) {
      const data = {
        ...values,
        subNsmps: values.subNsmps.map(sub => ({
          ...sub,
          arquivos: sub.arquivos.map(arq => {
            const { src, ...rest } = arq;
            return rest;
          }),
        })),
      };

      clearForm();
      onConfirm({ 
        ...data, 
        codigo: getCodigo(),
        dataFotoDrone: getDataFotoDrone(),
        updateFiles: editFiles
      });
    }
  }
  
  const getCodigo = () => {
    if (values && values.id) return values.codigo

    let codigo = Array.isArray(nsmps) && nsmps.length > 0 ? nsmps.filter(n => n.fotoInicio !== true && n.fotoFim !== true && n.analiseRisco !== true).length + 1 : 1;
    while ((codigo+'').length < 3) codigo = '0' + codigo;
    return codigo;
  }

  const isAdmin = () => userRole === Role.ADMIN || userRole === Role.SUPER_ADMIN;

  const getTitle = () => {
    if (values && values.analiseRisco) {
      return `${nsirTitle} > Análise de Risco`;
    }

    return `${nsirTitle} > Poste ID ${values.codigo}`;
  }

  const isFotoRegistro = () => values.fotoRegistro === true;
  const isNotService = () => values.fotoInicio === true || values.fotoFim === true || values.analiseRisco === true || isFotoRegistro();

  const renderOcorrenciaItem = subNsmp => {
    let enableInspecaoFields = nsirStatus === Status.EM_INSPECAO && inspetorId === userId;
    const enableDigitacaoFields = nsirStatus === Status.EM_DIGITACAO && digitadorId === userId;
    if (enableDigitacaoFields) {
      enableInspecaoFields = !!subNsmp.idSubNsmpReference;
    }

    const onUpdateSubNsmp = (field, value) => {
      const updatedData = { ...subNsmp, [field]: value } 
      const newSubNsmps = [];
      (values.subNsmps || []).forEach(data => {
        if (data.id === updatedData.id) {
          newSubNsmps.push(updatedData);
        } else {
          newSubNsmps.push(data);
        }
      });
      
      setValues({ ...values, subNsmps: newSubNsmps});
    }

    return <Grid key={subNsmp.id} container spacing={3} className={classes.posteContainer}>
      <Grid item xs={4}>
        <OptionSelect
          label="Ocorrência de Irregularidade Técnica"
          codigo="SUBNSMP_USO_MUTUO_TIPO_SERVICO"
          isRequired
          onSelect={tipoServico => onUpdateSubNsmp('tipoServico', tipoServico)}
          value={subNsmp.tipoServico}
          error={errors && errors.tipoServico}
          disabled={canEditNsmp ? false : !enableInspecaoFields}
        />
      </Grid>
      <Grid item xs={4}>
        <OptionSelect
          label="Atuação"
          codigo="SUBNSMP_USO_MUTUO_ACAO"
          isRequired
          onSelect={acao => onUpdateSubNsmp('acao', acao)}
          value={subNsmp.acao}
          error={errors && errors.acao}
          disabled={canEditNsmp ? false : !enableInspecaoFields}
        />
      </Grid>
      <Grid item xs={4}>
        <Input
          error={errors && errors.responsavel ? true : false}
          isRequired={isAdmin() ? false : nsirStatus === Status.EM_DIGITACAO}
          name="responsavel"
          label="Céssionária Responsável"
          value={subNsmp.responsavel}
          onChange={event => onUpdateSubNsmp(event.target.name, event.target.value)}
          disabled={canEditNsmp ? false : !enableInspecaoFields}
        />
      </Grid>
      <Grid item xs={12}>
        <Input
          label="Observação do Inspetor (outras informações)"
          name="observacaoInspetor"
          onChange={event => onUpdateSubNsmp(event.target.name, event.target.value)}
          multiline
          rows={2}
          value={subNsmp.observacaoInspetor}
          disabled={canEditNsmp ? false : !enableInspecaoFields}
        />
      </Grid>
      <Grid item xs={12}>
        <Input
          label="Observação do Digitador"
          name="observacaoDigitador"
          onChange={event => onUpdateSubNsmp(event.target.name, event.target.value)}
          multiline
          rows={2}
          value={subNsmp.observacaoDigitador}
          disabled={canEditNsmp ? false : !enableDigitacaoFields}
        />
      </Grid>
      <ArquivoContainer 
        collapse
        arquivos={subNsmp.arquivos}
        disabled
        showDescription
      />
    </Grid> 
  }

  const getOcorrenciaActions = subNsmp => {
    const subNsmpCodigo = padCodigo(subNsmp.codigo);

    const invalidarOption = { onClick: () => setOcorrenciaData({ open: true, type: "INVALIDADO", subNmspId: subNsmp.id, subNsmpCodigo: subNsmpCodigo }), title: 'Invalidar' };
    const validarOption = { onClick: () => setOcorrenciaData({ open: true, type: "VALIDADO", subNmspId: subNsmp.id, subNsmpCodigo: subNsmpCodigo }), title: 'Validar' };
    const clonarOption = { onClick: () => setClonarData({ open: true, subNmspId: subNsmp.id, subNsmpCodigo: subNsmpCodigo }), title: 'Clonar' };
    const deletarOption = { onClick: () => setDeletarData({ open: true, subNmspId: subNsmp.id, subNsmpCodigo: subNsmpCodigo }), title: 'Deletar' };

    const digitadorAvailable = nsirStatus === Status.EM_DIGITACAO && digitadorId === userId;
    const adminAvailable = isAdmin() && canEditNsmp;

    if (digitadorAvailable || adminAvailable) {
      const  availableOptions = [clonarOption];
      switch (subNsmp.validate) {
        case "INVALIDADO":
          availableOptions.push(validarOption);
          break;
        case "VALIDADO":
          availableOptions.push(invalidarOption);
          break;
        default:
          availableOptions.push(invalidarOption, validarOption);
          break;
      }

      if (!!subNsmp.idSubNsmpReference) {
        availableOptions.push(deletarOption);
      }

      return availableOptions;
    }


    return [];
  }

  const padCodigo = codigo => {
    const [first, ...rest] = codigo.split("_");
    const firstPadded = first.padStart(3, "0");
    return [firstPadded, ...rest].join("_");
  };

  const renderOcorrencias = () => {
    return (
      <Widget title="Ocorrências">
        {(values.subNsmps || []).map(currentSubNsmp => {
          let sufix = 'Aguardando Validação';
          switch (currentSubNsmp.validate) {
            case "INVALIDADO":
              sufix = 'Inválido'
              break;
            case "VALIDADO":
              sufix = 'Valido'
              break;
          }

          return <Grid className={classes.evidenciaContent}>
            <Widget title={`Ocorrência ${padCodigo(currentSubNsmp.codigo)} - ${sufix}`} classNameCard collapse actions={getOcorrenciaActions(currentSubNsmp)}>
              {renderOcorrenciaItem(currentSubNsmp)}
            </Widget>
          </Grid>
        })}
      </Widget>
    );
  }

  const sortByCode = subNsmpList => {
    return [...subNsmpList].sort((a, b) => {
      const aParts = a.codigo.split("_").map(Number);
      const bParts = b.codigo.split("_").map(Number);
      const len = Math.max(aParts.length, bParts.length);

      for (let i = 0; i < len; i++) {
        const aVal = aParts[i] ?? 0;
        const bVal = bParts[i] ?? 0;

        if (aVal !== bVal) {
          return aVal - bVal;
        }
      }

      return aParts.length - bParts.length;
    });
  };

  return (
    <>
      <DialogDefault
        open={open}
        handlerCancel={onCancelLocal}
        handlerConfirm={onConfirmLocal}
        title={getTitle()}
        confirmMessage={'Salvar'}
        fullScreen
        contentClassName={classes.dialogContent}
        readOnly={canEditNsmp? false : nsirStatus === Status.EM_DIGITACAO && !isNotService()? false : readOnlyLocal}
        headerAction={!isUsuarioUsoMuto(authData.email) && isAdmin() && readOnlyLocal ? {
          onClick: () => {
            setReadOnlyLocal(false);
            setCanEditNsmp(true);
          },
          title: 'Editar'
        } : null}
      >
        <Grid container spacing={3} className={classes.root}>
          <Grid item xs={6} sm={2}>
            <Input
              name="numeroPoste"
              label="Identificador Poste"
              disabled
              value={getCodigo()}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Input
              error={errors && errors.endereco ? true : false}
              isRequired
              label="Endereço"
              name="endereco"
              onChange={event => handleChange(event.target.name, event.target.value)}
              value={values.endereco}
              disabled={readOnlyLocal}
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <InputFormat
              error={errors && errors.latitude ? true : false}
              name="latitude"
              label="Latitude"
              value={values.latitude}
              onChange={event => handleChange(event.target.name, event.target.value)}
              disabled={readOnlyLocal}
              format="-##,#######"
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <InputFormat
              error={errors && errors.longitude ? true : false}
              name="longitude"
              label="Longitude"
              value={values.longitude}
              onChange={event => handleChange(event.target.name, event.target.value)}
              disabled={readOnlyLocal}
              format="-##,#######"
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <Input
              error={errors && errors.situacaoPoste ? true : false}
              isRequired
              label="Situação do Poste"
              name="situacaoPoste"
              onChange={event => handleChange(event.target.name, event.target.value)}
              value={values.situacaoPoste}
              disabled={readOnlyLocal}
            />
          </Grid>
          {(values.situacaoPoste === "Não compartilhável" || values.situacaoPoste === "Sem irregularidade") && <Grid item xs={12} className={classes.fieldContainer}>
            <Input
              error={errors && errors.observacao ? true : false}
              isRequired={values.situacaoPoste === "Não compartilhável" || values.situacaoPoste === "Sem irregularidade"}
              label="Descrição/Observação"
              name="observacao"
              onChange={event => handleChange(event.target.name, event.target.value)}
              placeholder="observacao"
              value={values.observacao}
              rows={2}
              multiline
              disabled={readOnlyLocal}
            />
          </Grid>}
          <Grid item xs={12} className={classes.root}>
            {renderOcorrencias()}
          </Grid>
          <ArquivoContainer 
            collapse
            arquivos={values.fotos}
            showDescription
            onSave={fotos => {
              setEditFiles(true);
              setValues({ ...values, fotos });
            }}
            disabled={canEditNsmp? false : readOnlyLocal}
          />
          <Grid item xs={12}>
            {errors && errors.fotos && 
              <p className={`MuiFormHelperText-root MuiFormHelperText-contained MuiFormHelperText-marginDense Mui-error ${classes.required}`}>*Imagens são obrigatórias</p>
            }
          </Grid>
        </Grid>
      </DialogDefault>
      <DialogDefault
        open={ocorrenciaData.open}
        handlerCancel={() => setOcorrenciaData({ open: false, type: "", subNmspId: null, subNsmpCodigo: null })}
        handlerConfirm={() => {
          validateInvalidateSubNsmp(ocorrenciaData.subNmspId, ocorrenciaData.type, () => {
            const updateSubNsmps = [];
            values.subNsmps.forEach(subNsmp => {
              if (subNsmp.id === ocorrenciaData.subNmspId) {
                subNsmp.validate = ocorrenciaData.type;
              }
              updateSubNsmps.push(subNsmp);
            });

            setValues({ ...values, subNsmps: updateSubNsmps });
            setOcorrenciaData({ open: false, type: "", subNmspId: null, subNsmpCodigo: null });
          });
        }}
        title={`Confirmação - ${ocorrenciaData.type === 'INVALIDADO' ? 'INVALIDAR' : 'VALIDAR' }`}
        confirmMessage="Sim"
      >
        <DialogContentText> 
          {ocorrenciaData.type === "VALIDADO"? `Deseja validar a ocorrência ${ocorrenciaData.subNsmpCodigo}?` : `Deseja invalidar a ocorrência ${ocorrenciaData.subNsmpCodigo}?`}  
        </DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={clonarData.open}
        handlerCancel={() => setClonarData({ open: false, subNmspId: null, subNsmpCodigo: null })}
        handlerConfirm={() => {
          cloneSubNsmp(clonarData.subNmspId, subNsmpClone => {
            setValues({ ...values, subNsmps: sortByCode([...values.subNsmps, subNsmpClone]) });
            setClonarData({ open: false, subNmspId: null, subNsmpCodigo: null });
          });
        }}
        title={`Confirmação - Clonagem`}
        confirmMessage="Sim"
      >
        <DialogContentText> 
          {`Deseja clonar a ocorrência ${clonarData.subNsmpCodigo}?`}
        </DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={deletarData.open}
        handlerCancel={() => setDeletarData({ open: false, subNmspId: null, subNsmpCodigo: null })}
        handlerConfirm={() => {
          deleteCloneSubNsmp(deletarData.subNmspId, subNsmpUpdatedList => {
            const removerIds = new Set(subNsmpUpdatedList.map(d => d.id));
            removerIds.add(deletarData.subNmspId);

            const resultado = values.subNsmps.filter(d => !removerIds.has(d.id));

            setValues({ ...values, subNsmps: sortByCode([...resultado, ...subNsmpUpdatedList]) });
            setDeletarData({ open: false, subNmspId: null, subNsmpCodigo: null });
          });
        }}
        title={`Confirmação - Deletar`}
        confirmMessage="Sim"
      >
        <DialogContentText> 
          {`Deseja deletar a ocorrência ${deletarData.subNsmpCodigo}?`}
        </DialogContentText>
      </DialogDefault>
    </>
  );
};

const mapStateToProps = state => ({
  nsmps: selectorsNsmp.getNsmps(state),
  nsmpSelected: selectorsNsmp.getNsmpSelected(state),
  userRole: selectorsAuth.getRole(state),
  authData: selectorsAuth.getAuth(state),
  nsirStatus: selectorsNsir.getNsirStatus(state),
  userId: selectorsAuth.getUserId(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsNsmp,
  ...actionsSubNsmp,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UsoMutuoNewModal);
